/* @generated from adl module krodok.snappy.api */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_adminui_api from './../../common/adminui/api';
import * as common_adminui_db from './../../common/adminui/db';
import * as common_db from './../../common/db';
import * as common_http from './../../common/http';
import * as common_strings from './../../common/strings';
import * as common_tabular from './../../common/tabular';
import * as krodok_snappy_db from './db';
import * as sys_types from './../../sys/types';

export interface ApiRequests {
  /**
   * Create a new application
   */
  createApplication: common_http.HttpPost<krodok_snappy_db.CompanyType, krodok_snappy_db.ApplicationId>;
  /**
   * Update an existing application
   */
  updateApplication: common_http.HttpPost<common_db.WithDbId<ApplicationReq>, UpdateApplicationResp>;
  /**
   * Get an application
   */
  queryApplication: common_http.HttpPost<QueryApplicationReq, QueryApplicationResp>;
  /**
   * Charge payment for an application
   */
  createPaymentIntentSecret: common_http.HttpPost<CreatePaymentIntentReq, CreatePaymentIntentResp>;
  checkPaymentIntent: common_http.HttpPost<krodok_snappy_db.ApplicationId, CheckPaymentIntentResp>;
  /**
   * Login a user
   */
  login: common_http.HttpPost<LoginReq, LoginResp>;
  /**
   * Post a message to the noticeboard
   */
  newMessage: common_http.HttpPost<NewMessageReq, common.Unit>;
  /**
   * Get recent noticeboard messages
   */
  recentMessages: common_http.HttpPost<RecentMessagesReq, common.Paginated<Message>>;
  /**
   * Gets the logged in user details
   */
  whoAmI: common_http.HttpGet<UserProfile>;
  /**
   * Create a new user
   */
  createUser: common_http.HttpPost<UserReq, krodok_snappy_db.AppUserId>;
  /**
   * Update an existing user
   */
  updateUser: common_http.HttpPost<common_db.WithDbId<UserReq>, common.Unit>;
  /**
   * Delete an existing user
   */
  deleteUser: common_http.HttpPost<krodok_snappy_db.AppUserId, common.Unit>;
  /**
   * Query existing users sorted and filters according to the
   * TableQuery request.
   */
  queryUsers: common_http.HttpPost<common_tabular.TableQuery, common.Paginated<common_db.WithDbId<krodok_snappy_db.AppUser>>>;
  /**
   * Requests to service the CRUD admin enpoints
   */
  admin: common_adminui_api.AdminApiRequests;
}

export function makeApiRequests(
  input: {
    createApplication?: common_http.HttpPost<krodok_snappy_db.CompanyType, krodok_snappy_db.ApplicationId>,
    updateApplication?: common_http.HttpPost<common_db.WithDbId<ApplicationReq>, UpdateApplicationResp>,
    queryApplication?: common_http.HttpPost<QueryApplicationReq, QueryApplicationResp>,
    createPaymentIntentSecret?: common_http.HttpPost<CreatePaymentIntentReq, CreatePaymentIntentResp>,
    checkPaymentIntent?: common_http.HttpPost<krodok_snappy_db.ApplicationId, CheckPaymentIntentResp>,
    login?: common_http.HttpPost<LoginReq, LoginResp>,
    newMessage?: common_http.HttpPost<NewMessageReq, common.Unit>,
    recentMessages?: common_http.HttpPost<RecentMessagesReq, common.Paginated<Message>>,
    whoAmI?: common_http.HttpGet<UserProfile>,
    createUser?: common_http.HttpPost<UserReq, krodok_snappy_db.AppUserId>,
    updateUser?: common_http.HttpPost<common_db.WithDbId<UserReq>, common.Unit>,
    deleteUser?: common_http.HttpPost<krodok_snappy_db.AppUserId, common.Unit>,
    queryUsers?: common_http.HttpPost<common_tabular.TableQuery, common.Paginated<common_db.WithDbId<krodok_snappy_db.AppUser>>>,
    admin?: common_adminui_api.AdminApiRequests,
  }
): ApiRequests {
  return {
    createApplication: input.createApplication === undefined ? {path : "/applications/create", security : {kind : "public"}, reqType : krodok_snappy_db.texprCompanyType(), respType : krodok_snappy_db.texprApplicationId()} : input.createApplication,
    updateApplication: input.updateApplication === undefined ? {path : "/applications/update", security : {kind : "public"}, reqType : common_db.texprWithDbId(texprApplicationReq()), respType : texprUpdateApplicationResp()} : input.updateApplication,
    queryApplication: input.queryApplication === undefined ? {path : "/applications/query", security : {kind : "public"}, reqType : texprQueryApplicationReq(), respType : texprQueryApplicationResp()} : input.queryApplication,
    createPaymentIntentSecret: input.createPaymentIntentSecret === undefined ? {path : "/payments/create", security : {kind : "public"}, reqType : texprCreatePaymentIntentReq(), respType : texprCreatePaymentIntentResp()} : input.createPaymentIntentSecret,
    checkPaymentIntent: input.checkPaymentIntent === undefined ? {path : "/payments/check", security : {kind : "public"}, reqType : krodok_snappy_db.texprApplicationId(), respType : texprCheckPaymentIntentResp()} : input.checkPaymentIntent,
    login: input.login === undefined ? {path : "/login", security : {kind : "public"}, reqType : texprLoginReq(), respType : texprLoginResp()} : input.login,
    newMessage: input.newMessage === undefined ? {path : "/messages/new", security : {kind : "token"}, reqType : texprNewMessageReq(), respType : common.texprUnit()} : input.newMessage,
    recentMessages: input.recentMessages === undefined ? {path : "/messages/recent", security : {kind : "token"}, reqType : texprRecentMessagesReq(), respType : common.texprPaginated(texprMessage())} : input.recentMessages,
    whoAmI: input.whoAmI === undefined ? {path : "/whoami", security : {kind : "token"}, respType : texprUserProfile()} : input.whoAmI,
    createUser: input.createUser === undefined ? {path : "/users/create", security : {kind : "tokenWithRole", value : "admin"}, reqType : texprUserReq(), respType : krodok_snappy_db.texprAppUserId()} : input.createUser,
    updateUser: input.updateUser === undefined ? {path : "/users/update", security : {kind : "tokenWithRole", value : "admin"}, reqType : common_db.texprWithDbId(texprUserReq()), respType : common.texprUnit()} : input.updateUser,
    deleteUser: input.deleteUser === undefined ? {path : "/users/delete", security : {kind : "tokenWithRole", value : "admin"}, reqType : krodok_snappy_db.texprAppUserId(), respType : common.texprUnit()} : input.deleteUser,
    queryUsers: input.queryUsers === undefined ? {path : "/users/query", security : {kind : "tokenWithRole", value : "admin"}, reqType : common_tabular.texprTableQuery(), respType : common.texprPaginated(common_db.texprWithDbId(krodok_snappy_db.texprAppUser()))} : input.queryUsers,
    admin: input.admin === undefined ? {queryTables : {path : "/admin/meta/tables", security : {kind : "tokenWithRole", value : "admin"}, reqType : common_tabular.texprTableQuery(), respType : common.texprPaginated(common_adminui_api.texprTable())}, queryDecls : {path : "/admin/meta/decls", security : {kind : "tokenWithRole", value : "admin"}, reqType : common_tabular.texprTableQuery(), respType : common.texprPaginated(common_adminui_db.texprMetaAdlDecl())}, query : {path : "/admin/query", security : {kind : "tokenWithRole", value : "admin"}, reqType : common_adminui_api.texprQueryReq(), respType : common.texprPaginated(common_db.texprWithDbId(common_adminui_api.texprDbRow()))}, create : {path : "/admin/create", security : {kind : "tokenWithRole", value : "admin"}, reqType : common_adminui_api.texprCreateReq(), respType : common_adminui_api.texprDbResult(common_adminui_api.texprDbId())}, update : {path : "/admin/update", security : {kind : "tokenWithRole", value : "admin"}, reqType : common_adminui_api.texprUpdateReq(), respType : common_adminui_api.texprDbResult(common.texprUnit())}, delete : {path : "/admin/delete", security : {kind : "tokenWithRole", value : "admin"}, reqType : common_adminui_api.texprDeleteReq(), respType : common_adminui_api.texprDbResult(common.texprUnit())}, dbKeyLabels : {path : "/admin/dbkeylabels", security : {kind : "tokenWithRole", value : "admin"}, reqType : ADL.texprVector(common_adminui_api.texprDbKeyLabelReq()), respType : ADL.texprVector(common_adminui_api.texprDbKeyLabelResp())}} : input.admin,
  };
}

const ApiRequests_AST : ADL.ScopedDecl =
  {"moduleName":"krodok.snappy.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Create a new application\n"}],"serializedName":"createApplication","default":{"kind":"just","value":{"path":"/applications/create","security":"public"}},"name":"createApplication","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"krodok.snappy.db","name":"CompanyType"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"krodok.snappy.db","name":"ApplicationId"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Update an existing application\n"}],"serializedName":"updateApplication","default":{"kind":"just","value":{"path":"/applications/update","security":"public"}},"name":"updateApplication","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"krodok.snappy.api","name":"ApplicationReq"}},"parameters":[]}]},{"typeRef":{"kind":"reference","value":{"moduleName":"krodok.snappy.api","name":"UpdateApplicationResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Get an application\n"}],"serializedName":"queryApplication","default":{"kind":"just","value":{"path":"/applications/query","security":"public"}},"name":"queryApplication","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"krodok.snappy.api","name":"QueryApplicationReq"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"krodok.snappy.api","name":"QueryApplicationResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Charge payment for an application\n"}],"serializedName":"createPaymentIntentSecret","default":{"kind":"just","value":{"path":"/payments/create","security":"public"}},"name":"createPaymentIntentSecret","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"krodok.snappy.api","name":"CreatePaymentIntentReq"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"krodok.snappy.api","name":"CreatePaymentIntentResp"}},"parameters":[]}]}},{"annotations":[],"serializedName":"checkPaymentIntent","default":{"kind":"just","value":{"path":"/payments/check","security":"public"}},"name":"checkPaymentIntent","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"krodok.snappy.db","name":"ApplicationId"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"krodok.snappy.api","name":"CheckPaymentIntentResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Login a user\n"}],"serializedName":"login","default":{"kind":"just","value":{"path":"/login","security":"public"}},"name":"login","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"krodok.snappy.api","name":"LoginReq"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"krodok.snappy.api","name":"LoginResp"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Post a message to the noticeboard\n"}],"serializedName":"newMessage","default":{"kind":"just","value":{"path":"/messages/new","security":"token"}},"name":"newMessage","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"krodok.snappy.api","name":"NewMessageReq"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Get recent noticeboard messages\n"}],"serializedName":"recentMessages","default":{"kind":"just","value":{"path":"/messages/recent","security":"token"}},"name":"recentMessages","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"krodok.snappy.api","name":"RecentMessagesReq"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Paginated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"krodok.snappy.api","name":"Message"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Gets the logged in user details\n"}],"serializedName":"whoAmI","default":{"kind":"just","value":{"path":"/whoami","security":"token"}},"name":"whoAmI","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpGet"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"krodok.snappy.api","name":"UserProfile"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Create a new user\n"}],"serializedName":"createUser","default":{"kind":"just","value":{"path":"/users/create","security":{"tokenWithRole":"admin"}}},"name":"createUser","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"krodok.snappy.api","name":"UserReq"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"krodok.snappy.db","name":"AppUserId"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Update an existing user\n"}],"serializedName":"updateUser","default":{"kind":"just","value":{"path":"/users/update","security":{"tokenWithRole":"admin"}}},"name":"updateUser","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"krodok.snappy.api","name":"UserReq"}},"parameters":[]}]},{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Delete an existing user\n"}],"serializedName":"deleteUser","default":{"kind":"just","value":{"path":"/users/delete","security":{"tokenWithRole":"admin"}}},"name":"deleteUser","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"krodok.snappy.db","name":"AppUserId"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Unit"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Query existing users sorted and filters according to the\nTableQuery request.\n"}],"serializedName":"queryUsers","default":{"kind":"just","value":{"path":"/users/query","security":{"tokenWithRole":"admin"}}},"name":"queryUsers","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.http","name":"HttpPost"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.tabular","name":"TableQuery"}},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Paginated"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"WithDbId"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"krodok.snappy.db","name":"AppUser"}},"parameters":[]}]}]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Requests to service the CRUD admin enpoints\n"}],"serializedName":"admin","default":{"kind":"just","value":{"queryTables":{"path":"/admin/meta/tables","security":{"tokenWithRole":"admin"}},"queryDecls":{"path":"/admin/meta/decls","security":{"tokenWithRole":"admin"}},"create":{"path":"/admin/create","security":{"tokenWithRole":"admin"}},"query":{"path":"/admin/query","security":{"tokenWithRole":"admin"}},"delete":{"path":"/admin/delete","security":{"tokenWithRole":"admin"}},"update":{"path":"/admin/update","security":{"tokenWithRole":"admin"}}}},"name":"admin","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.adminui.api","name":"AdminApiRequests"}},"parameters":[]}}]}},"name":"ApiRequests","version":{"kind":"nothing"}}};

export const snApiRequests: ADL.ScopedName = {moduleName:"krodok.snappy.api", name:"ApiRequests"};

export function texprApiRequests(): ADL.ATypeExpr<ApiRequests> {
  return {value : {typeRef : {kind: "reference", value : snApiRequests}, parameters : []}};
}

export interface ApplicationReq {
  companyType: krodok_snappy_db.CompanyType;
  contactEmail: string;
  acceptedTOS: boolean;
  applicationData: krodok_snappy_db.LoanSuiteApplication;
}

export function makeApplicationReq(
  input: {
    companyType: krodok_snappy_db.CompanyType,
    contactEmail: string,
    acceptedTOS: boolean,
    applicationData: krodok_snappy_db.LoanSuiteApplication,
  }
): ApplicationReq {
  return {
    companyType: input.companyType,
    contactEmail: input.contactEmail,
    acceptedTOS: input.acceptedTOS,
    applicationData: input.applicationData,
  };
}

const ApplicationReq_AST : ADL.ScopedDecl =
  {"moduleName":"krodok.snappy.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"companyType","default":{"kind":"nothing"},"name":"companyType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"krodok.snappy.db","name":"CompanyType"}},"parameters":[]}},{"annotations":[],"serializedName":"contactEmail","default":{"kind":"nothing"},"name":"contactEmail","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"acceptedTOS","default":{"kind":"nothing"},"name":"acceptedTOS","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"applicationData","default":{"kind":"nothing"},"name":"applicationData","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"krodok.snappy.db","name":"LoanSuiteApplication"}},"parameters":[]}}]}},"name":"ApplicationReq","version":{"kind":"nothing"}}};

export const snApplicationReq: ADL.ScopedName = {moduleName:"krodok.snappy.api", name:"ApplicationReq"};

export function texprApplicationReq(): ADL.ATypeExpr<ApplicationReq> {
  return {value : {typeRef : {kind: "reference", value : snApplicationReq}, parameters : []}};
}

export interface QueryApplicationReq {
  id: krodok_snappy_db.ApplicationId;
}

export function makeQueryApplicationReq(
  input: {
    id: krodok_snappy_db.ApplicationId,
  }
): QueryApplicationReq {
  return {
    id: input.id,
  };
}

const QueryApplicationReq_AST : ADL.ScopedDecl =
  {"moduleName":"krodok.snappy.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"krodok.snappy.db","name":"ApplicationId"}},"parameters":[]}}]}},"name":"QueryApplicationReq","version":{"kind":"nothing"}}};

export const snQueryApplicationReq: ADL.ScopedName = {moduleName:"krodok.snappy.api", name:"QueryApplicationReq"};

export function texprQueryApplicationReq(): ADL.ATypeExpr<QueryApplicationReq> {
  return {value : {typeRef : {kind: "reference", value : snQueryApplicationReq}, parameters : []}};
}

export interface QueryApplicationResp_Application {
  kind: 'application';
  value: krodok_snappy_db.Application;
}
export interface QueryApplicationResp_InvalidApplicationId {
  kind: 'invalidApplicationId';
}

export type QueryApplicationResp = QueryApplicationResp_Application | QueryApplicationResp_InvalidApplicationId;

export interface QueryApplicationRespOpts {
  application: krodok_snappy_db.Application;
  invalidApplicationId: null;
}

export function makeQueryApplicationResp<K extends keyof QueryApplicationRespOpts>(kind: K, value: QueryApplicationRespOpts[K]) { return {kind, value}; }

const QueryApplicationResp_AST : ADL.ScopedDecl =
  {"moduleName":"krodok.snappy.api","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"application","default":{"kind":"nothing"},"name":"application","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"krodok.snappy.db","name":"Application"}},"parameters":[]}},{"annotations":[],"serializedName":"invalidApplicationId","default":{"kind":"nothing"},"name":"invalidApplicationId","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"QueryApplicationResp","version":{"kind":"nothing"}}};

export const snQueryApplicationResp: ADL.ScopedName = {moduleName:"krodok.snappy.api", name:"QueryApplicationResp"};

export function texprQueryApplicationResp(): ADL.ATypeExpr<QueryApplicationResp> {
  return {value : {typeRef : {kind: "reference", value : snQueryApplicationResp}, parameters : []}};
}

export enum UpdateApplicationResp {
  success,
  contactEmailInvalidFormat,
  companyEmailInvalidFormat,
  acnInvalidLength,
}

const UpdateApplicationResp_AST : ADL.ScopedDecl =
  {"moduleName":"krodok.snappy.api","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"success","default":{"kind":"nothing"},"name":"success","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"contactEmailInvalidFormat","default":{"kind":"nothing"},"name":"contactEmailInvalidFormat","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"companyEmailInvalidFormat","default":{"kind":"nothing"},"name":"companyEmailInvalidFormat","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"acnInvalidLength","default":{"kind":"nothing"},"name":"acnInvalidLength","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"UpdateApplicationResp","version":{"kind":"nothing"}}};

export const snUpdateApplicationResp: ADL.ScopedName = {moduleName:"krodok.snappy.api", name:"UpdateApplicationResp"};

export function texprUpdateApplicationResp(): ADL.ATypeExpr<UpdateApplicationResp> {
  return {value : {typeRef : {kind: "reference", value : snUpdateApplicationResp}, parameters : []}};
}

export interface CreatePaymentIntentResp_ClientSecret {
  kind: 'clientSecret';
  value: string;
}
export interface CreatePaymentIntentResp_StripeError {
  kind: 'stripeError';
  value: StripeError;
}
export interface CreatePaymentIntentResp_InvalidApplicationId {
  kind: 'invalidApplicationId';
}

export type CreatePaymentIntentResp = CreatePaymentIntentResp_ClientSecret | CreatePaymentIntentResp_StripeError | CreatePaymentIntentResp_InvalidApplicationId;

export interface CreatePaymentIntentRespOpts {
  clientSecret: string;
  stripeError: StripeError;
  invalidApplicationId: null;
}

export function makeCreatePaymentIntentResp<K extends keyof CreatePaymentIntentRespOpts>(kind: K, value: CreatePaymentIntentRespOpts[K]) { return {kind, value}; }

const CreatePaymentIntentResp_AST : ADL.ScopedDecl =
  {"moduleName":"krodok.snappy.api","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"clientSecret","default":{"kind":"nothing"},"name":"clientSecret","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"stripeError","default":{"kind":"nothing"},"name":"stripeError","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"krodok.snappy.api","name":"StripeError"}},"parameters":[]}},{"annotations":[],"serializedName":"invalidApplicationId","default":{"kind":"nothing"},"name":"invalidApplicationId","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"CreatePaymentIntentResp","version":{"kind":"nothing"}}};

export const snCreatePaymentIntentResp: ADL.ScopedName = {moduleName:"krodok.snappy.api", name:"CreatePaymentIntentResp"};

export function texprCreatePaymentIntentResp(): ADL.ATypeExpr<CreatePaymentIntentResp> {
  return {value : {typeRef : {kind: "reference", value : snCreatePaymentIntentResp}, parameters : []}};
}

export interface CreatePaymentIntentReq {
  secret: sys_types.Maybe<string>;
  applicationId: krodok_snappy_db.ApplicationId;
}

export function makeCreatePaymentIntentReq(
  input: {
    secret: sys_types.Maybe<string>,
    applicationId: krodok_snappy_db.ApplicationId,
  }
): CreatePaymentIntentReq {
  return {
    secret: input.secret,
    applicationId: input.applicationId,
  };
}

const CreatePaymentIntentReq_AST : ADL.ScopedDecl =
  {"moduleName":"krodok.snappy.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"secret","default":{"kind":"nothing"},"name":"secret","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"sys.types","name":"Maybe"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"applicationId","default":{"kind":"nothing"},"name":"applicationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"krodok.snappy.db","name":"ApplicationId"}},"parameters":[]}}]}},"name":"CreatePaymentIntentReq","version":{"kind":"nothing"}}};

export const snCreatePaymentIntentReq: ADL.ScopedName = {moduleName:"krodok.snappy.api", name:"CreatePaymentIntentReq"};

export function texprCreatePaymentIntentReq(): ADL.ATypeExpr<CreatePaymentIntentReq> {
  return {value : {typeRef : {kind: "reference", value : snCreatePaymentIntentReq}, parameters : []}};
}

export interface CheckPaymentIntentResp_Success {
  kind: 'success';
}
export interface CheckPaymentIntentResp_Unsuccesful {
  kind: 'unsuccesful';
}
export interface CheckPaymentIntentResp_ErrorMessage {
  kind: 'errorMessage';
  value: string;
}

export type CheckPaymentIntentResp = CheckPaymentIntentResp_Success | CheckPaymentIntentResp_Unsuccesful | CheckPaymentIntentResp_ErrorMessage;

export interface CheckPaymentIntentRespOpts {
  success: null;
  unsuccesful: null;
  errorMessage: string;
}

export function makeCheckPaymentIntentResp<K extends keyof CheckPaymentIntentRespOpts>(kind: K, value: CheckPaymentIntentRespOpts[K]) { return {kind, value}; }

const CheckPaymentIntentResp_AST : ADL.ScopedDecl =
  {"moduleName":"krodok.snappy.api","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"success","default":{"kind":"nothing"},"name":"success","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"unsuccesful","default":{"kind":"nothing"},"name":"unsuccesful","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"errorMessage","default":{"kind":"nothing"},"name":"errorMessage","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"CheckPaymentIntentResp","version":{"kind":"nothing"}}};

export const snCheckPaymentIntentResp: ADL.ScopedName = {moduleName:"krodok.snappy.api", name:"CheckPaymentIntentResp"};

export function texprCheckPaymentIntentResp(): ADL.ATypeExpr<CheckPaymentIntentResp> {
  return {value : {typeRef : {kind: "reference", value : snCheckPaymentIntentResp}, parameters : []}};
}

export interface StripeError {
  message: string;
}

export function makeStripeError(
  input: {
    message: string,
  }
): StripeError {
  return {
    message: input.message,
  };
}

const StripeError_AST : ADL.ScopedDecl =
  {"moduleName":"krodok.snappy.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"message","default":{"kind":"nothing"},"name":"message","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"StripeError","version":{"kind":"nothing"}}};

export const snStripeError: ADL.ScopedName = {moduleName:"krodok.snappy.api", name:"StripeError"};

export function texprStripeError(): ADL.ATypeExpr<StripeError> {
  return {value : {typeRef : {kind: "reference", value : snStripeError}, parameters : []}};
}

export interface UserProfile {
  id: krodok_snappy_db.AppUserId;
  fullname: string;
  email: string;
  isAdmin: boolean;
}

export function makeUserProfile(
  input: {
    id: krodok_snappy_db.AppUserId,
    fullname: string,
    email: string,
    isAdmin: boolean,
  }
): UserProfile {
  return {
    id: input.id,
    fullname: input.fullname,
    email: input.email,
    isAdmin: input.isAdmin,
  };
}

const UserProfile_AST : ADL.ScopedDecl =
  {"moduleName":"krodok.snappy.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"krodok.snappy.db","name":"AppUserId"}},"parameters":[]}},{"annotations":[],"serializedName":"fullname","default":{"kind":"nothing"},"name":"fullname","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"email","default":{"kind":"nothing"},"name":"email","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"isAdmin","default":{"kind":"nothing"},"name":"isAdmin","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"UserProfile","version":{"kind":"nothing"}}};

export const snUserProfile: ADL.ScopedName = {moduleName:"krodok.snappy.api", name:"UserProfile"};

export function texprUserProfile(): ADL.ATypeExpr<UserProfile> {
  return {value : {typeRef : {kind: "reference", value : snUserProfile}, parameters : []}};
}

/**
 * Details for a user
 */
export interface UserReq {
  fullname: string;
  email: string;
  password: string;
}

export function makeUserReq(
  input: {
    fullname: string,
    email: string,
    password: string,
  }
): UserReq {
  return {
    fullname: input.fullname,
    email: input.email,
    password: input.password,
  };
}

const UserReq_AST : ADL.ScopedDecl =
  {"moduleName":"krodok.snappy.api","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Details for a user\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"fullname","default":{"kind":"nothing"},"name":"fullname","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"email","default":{"kind":"nothing"},"name":"email","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"password","default":{"kind":"nothing"},"name":"password","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"UserReq","version":{"kind":"nothing"}}};

export const snUserReq: ADL.ScopedName = {moduleName:"krodok.snappy.api", name:"UserReq"};

export function texprUserReq(): ADL.ATypeExpr<UserReq> {
  return {value : {typeRef : {kind: "reference", value : snUserReq}, parameters : []}};
}

export interface LoginReq {
  email: common_strings.StringNE;
  password: common_strings.StringNE;
}

export function makeLoginReq(
  input: {
    email: common_strings.StringNE,
    password: common_strings.StringNE,
  }
): LoginReq {
  return {
    email: input.email,
    password: input.password,
  };
}

const LoginReq_AST : ADL.ScopedDecl =
  {"moduleName":"krodok.snappy.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"email","default":{"kind":"nothing"},"name":"email","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"password","default":{"kind":"nothing"},"name":"password","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}]}},"name":"LoginReq","version":{"kind":"nothing"}}};

export const snLoginReq: ADL.ScopedName = {moduleName:"krodok.snappy.api", name:"LoginReq"};

export function texprLoginReq(): ADL.ATypeExpr<LoginReq> {
  return {value : {typeRef : {kind: "reference", value : snLoginReq}, parameters : []}};
}

export interface LoginResp_AccessToken {
  kind: 'accessToken';
  value: common_strings.StringNE;
}
export interface LoginResp_InvalidCredentials {
  kind: 'invalidCredentials';
}

export type LoginResp = LoginResp_AccessToken | LoginResp_InvalidCredentials;

export interface LoginRespOpts {
  accessToken: common_strings.StringNE;
  invalidCredentials: null;
}

export function makeLoginResp<K extends keyof LoginRespOpts>(kind: K, value: LoginRespOpts[K]) { return {kind, value}; }

const LoginResp_AST : ADL.ScopedDecl =
  {"moduleName":"krodok.snappy.api","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"accessToken","default":{"kind":"nothing"},"name":"accessToken","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"invalidCredentials","default":{"kind":"nothing"},"name":"invalidCredentials","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"LoginResp","version":{"kind":"nothing"}}};

export const snLoginResp: ADL.ScopedName = {moduleName:"krodok.snappy.api", name:"LoginResp"};

export function texprLoginResp(): ADL.ATypeExpr<LoginResp> {
  return {value : {typeRef : {kind: "reference", value : snLoginResp}, parameters : []}};
}

export interface NewMessageReq {
  message: common_strings.StringML;
}

export function makeNewMessageReq(
  input: {
    message: common_strings.StringML,
  }
): NewMessageReq {
  return {
    message: input.message,
  };
}

const NewMessageReq_AST : ADL.ScopedDecl =
  {"moduleName":"krodok.snappy.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"message","default":{"kind":"nothing"},"name":"message","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringML"}},"parameters":[]}}]}},"name":"NewMessageReq","version":{"kind":"nothing"}}};

export const snNewMessageReq: ADL.ScopedName = {moduleName:"krodok.snappy.api", name:"NewMessageReq"};

export function texprNewMessageReq(): ADL.ATypeExpr<NewMessageReq> {
  return {value : {typeRef : {kind: "reference", value : snNewMessageReq}, parameters : []}};
}

export interface RecentMessagesReq {
  offset: number;
  count: number;
}

export function makeRecentMessagesReq(
  input: {
    offset?: number,
    count?: number,
  }
): RecentMessagesReq {
  return {
    offset: input.offset === undefined ? 0 : input.offset,
    count: input.count === undefined ? 20 : input.count,
  };
}

const RecentMessagesReq_AST : ADL.ScopedDecl =
  {"moduleName":"krodok.snappy.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"offset","default":{"kind":"just","value":0},"name":"offset","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}},{"annotations":[],"serializedName":"count","default":{"kind":"just","value":20},"name":"count","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}}]}},"name":"RecentMessagesReq","version":{"kind":"nothing"}}};

export const snRecentMessagesReq: ADL.ScopedName = {moduleName:"krodok.snappy.api", name:"RecentMessagesReq"};

export function texprRecentMessagesReq(): ADL.ATypeExpr<RecentMessagesReq> {
  return {value : {typeRef : {kind: "reference", value : snRecentMessagesReq}, parameters : []}};
}

export interface Message {
  id: krodok_snappy_db.MessageId;
  postedAt: common.Instant;
  userFullName: string;
  message: common_strings.StringML;
}

export function makeMessage(
  input: {
    id: krodok_snappy_db.MessageId,
    postedAt: common.Instant,
    userFullName: string,
    message: common_strings.StringML,
  }
): Message {
  return {
    id: input.id,
    postedAt: input.postedAt,
    userFullName: input.userFullName,
    message: input.message,
  };
}

const Message_AST : ADL.ScopedDecl =
  {"moduleName":"krodok.snappy.api","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"krodok.snappy.db","name":"MessageId"}},"parameters":[]}},{"annotations":[],"serializedName":"postedAt","default":{"kind":"nothing"},"name":"postedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"userFullName","default":{"kind":"nothing"},"name":"userFullName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"message","default":{"kind":"nothing"},"name":"message","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringML"}},"parameters":[]}}]}},"name":"Message","version":{"kind":"nothing"}}};

export const snMessage: ADL.ScopedName = {moduleName:"krodok.snappy.api", name:"Message"};

export function texprMessage(): ADL.ATypeExpr<Message> {
  return {value : {typeRef : {kind: "reference", value : snMessage}, parameters : []}};
}

/**
 * Stripe charge
 */
export interface Payment {
  tokenId: common_strings.StringNE;
}

export function makePayment(
  input: {
    tokenId: common_strings.StringNE,
  }
): Payment {
  return {
    tokenId: input.tokenId,
  };
}

const Payment_AST : ADL.ScopedDecl =
  {"moduleName":"krodok.snappy.api","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Stripe charge\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"tokenId","default":{"kind":"nothing"},"name":"tokenId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}]}},"name":"Payment","version":{"kind":"nothing"}}};

export const snPayment: ADL.ScopedName = {moduleName:"krodok.snappy.api", name:"Payment"};

export function texprPayment(): ADL.ATypeExpr<Payment> {
  return {value : {typeRef : {kind: "reference", value : snPayment}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "krodok.snappy.api.ApiRequests" : ApiRequests_AST,
  "krodok.snappy.api.ApplicationReq" : ApplicationReq_AST,
  "krodok.snappy.api.QueryApplicationReq" : QueryApplicationReq_AST,
  "krodok.snappy.api.QueryApplicationResp" : QueryApplicationResp_AST,
  "krodok.snappy.api.UpdateApplicationResp" : UpdateApplicationResp_AST,
  "krodok.snappy.api.CreatePaymentIntentResp" : CreatePaymentIntentResp_AST,
  "krodok.snappy.api.CreatePaymentIntentReq" : CreatePaymentIntentReq_AST,
  "krodok.snappy.api.CheckPaymentIntentResp" : CheckPaymentIntentResp_AST,
  "krodok.snappy.api.StripeError" : StripeError_AST,
  "krodok.snappy.api.UserProfile" : UserProfile_AST,
  "krodok.snappy.api.UserReq" : UserReq_AST,
  "krodok.snappy.api.LoginReq" : LoginReq_AST,
  "krodok.snappy.api.LoginResp" : LoginResp_AST,
  "krodok.snappy.api.NewMessageReq" : NewMessageReq_AST,
  "krodok.snappy.api.RecentMessagesReq" : RecentMessagesReq_AST,
  "krodok.snappy.api.Message" : Message_AST,
  "krodok.snappy.api.Payment" : Payment_AST
};
